import { render, staticRenderFns } from "./myClassList.vue?vue&type=template&id=616531ad"
import script from "./myClassList.vue?vue&type=script&lang=js"
export * from "./myClassList.vue?vue&type=script&lang=js"
import style0 from "./myClassList.vue?vue&type=style&index=0&id=616531ad&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports